import { Brand, Config, Effect, Option, Schema } from 'effect';

import { ConfigKey } from './keys';

export const PublicBackendOrigin = Schema.URL.pipe(Schema.brand('PublicBackendOrigin'));
export type PublicBackendOrigin = typeof PublicBackendOrigin.Type;

export const ServerBackendOrigin = Schema.URL.pipe(Schema.brand('ServerBackendOrigin'));
export type ServerBackendOrigin = typeof ServerBackendOrigin.Type;

export type BackendRequestEndpoint = string & Brand.Brand<'BackendRequestEndpoint'>;
const makeBackendRequestEndpoint = Brand.nominal<BackendRequestEndpoint>();

export type BrowserResourceEndpoint = string & Brand.Brand<'BrowserResourceEndpoint'>;
const makeBrowserResourceEndpoint = Brand.nominal<BrowserResourceEndpoint>();

export const PublicBackendOriginConfig = Config.schema(
  PublicBackendOrigin,
  ConfigKey.ApiEntrypoint
);
// Absent means "use the public origin". An invalid value still fails.
export const ServerBackendOriginConfig = Config.option(
  Config.schema(ServerBackendOrigin, ConfigKey.ApiServerEntrypoint)
);
const toEndpoint = (url: URL | string) => url.toString().replace(/\/$/, '');

const getPublicEndpoint = Effect.map(PublicBackendOriginConfig, toEndpoint);

const getServerEndpoint = Effect.gen(function* () {
  const serverOrigin = yield* ServerBackendOriginConfig;

  return Option.isSome(serverOrigin) ? toEndpoint(serverOrigin.value) : yield* getPublicEndpoint;
});

export const getBackendRequestEndpoint = Effect.suspend(() =>
  typeof window === 'undefined' ? getServerEndpoint : getPublicEndpoint
).pipe(Effect.map(makeBackendRequestEndpoint));

// Server renders still emit browser-reachable URLs.
export const getBrowserResourceEndpoint = getPublicEndpoint.pipe(
  Effect.map(makeBrowserResourceEndpoint)
);

export const getApiSyliusChannel = Config.NonEmptyString(ConfigKey.SyliusChannelCode);
